module.exports = __webpack_public_path__ + "a0b55a32799a9d63caf44a7c5873d50b.pdf";